import { atom } from "recoil";

export const applianceAddState = atom({
  key: "applianceAddState",
  default: false,
});

export const applianceEditState = atom({
  key: "applianceEditState",
  default: false,
});

export const applianceViewDetails = atom({
  key: "applianceViewDetails",
  default: undefined,
});

export const applianceShowDetails = atom({
  key: "applianceShowDetails",
  default: false,
});

export const pagination = atom({
  key: "paginationData",
  default: 0,
});

export const isFilter = atom({
  key: "isFilter",
  default: false,
});

export const officeApplianceForEdit = atom({
  key: "officeApplianceForEdit",
  default: undefined,
});

export const applianceOfficeId = atom({
  key: "applianceOfficeId",
  default: null,
});

export const showApplianceFromOffice = atom({
  key: "showApplianceFromOffice",
  default: false,
});
